import React, { useEffect, useRef } from 'react';
import { Dialog, DialogContent, DialogTitle, Slide, Stack, Typography, Avatar, IconButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PhoneDisconnect } from 'phosphor-react';
import createAvatar from '../utils/createAvatar';
import { useSelector, useDispatch } from 'react-redux';
import { denyCall } from '../redux/slices/call';
import useSocket from '../hooks/useSocket';
import { PROFILE_IMAGE_URL } from '../config'; // Import PROFILE_IMAGE_URL

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RingingModal = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { denyCall: emitDenyCall, BASE_URL } = useSocket(); // Socket emit function
  const { ringingModalOpen, activeCallDetails } = useSelector((state) => state.call);

  console.log("[RingingModal] Component re-rendered. ringingModalOpen:", ringingModalOpen, "activeCallDetails:", activeCallDetails);


  const receiverName = activeCallDetails?.receiverName || 'Unknown';
  const receiverId = activeCallDetails?.receiverId;
  const type = activeCallDetails?.type || 'audio';

  const avatarProps = createAvatar(receiverName);
  const avatarSrc = activeCallDetails?.receiverAvatar
    ? (activeCallDetails.receiverAvatar.startsWith('http')
      ? activeCallDetails.receiverAvatar
      : `${PROFILE_IMAGE_URL}${receiverId}`) // Use PROFILE_IMAGE_URL
    : undefined;

  const handleCancelCall = () => {
    console.log("[RingingModal] handleCancelCall triggered.");
    if (activeCallDetails?.callerId && activeCallDetails?.receiverId) {
      emitDenyCall(activeCallDetails.receiverId); // Deny the call to the receiver
    }
    dispatch(denyCall()); // Update Redux state
  };

  return (
    <Dialog
      open={ringingModalOpen}
      TransitionComponent={Transition}
      onClose={handleCancelCall} // Allow closing with backdrop click to deny
      aria-describedby="ringing-modal-description"
      fullWidth // Make the dialog take full width up to maxWidth
      maxWidth="xs" // Set maximum width to extra-small
      sx={{ zIndex: 1400, '& .MuiDialog-paper': { borderRadius: 4 } }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 0 }}>
        <Typography variant="h5" sx={{ color: theme.palette.text.primary }}>
          {type === 'audio' ? 'Audio Call' : 'Video Call'}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Stack spacing={3} alignItems="center" justifyContent="center">
          <Avatar
            src={avatarSrc}
            alt={receiverName}
            sx={{
              width: 120,
              height: 120,
              fontSize: '3rem',
              bgcolor: avatarProps.color,
              color: theme.palette.getContrastText(avatarProps.color),
            }}
          >
            {!avatarSrc && avatarProps.name}
          </Avatar>
          <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
            {receiverName}
          </Typography>
          <Typography variant="subtitle2" sx={{ color: theme.palette.text.secondary }}>
            {type === 'audio' ? 'Calling...' : 'Video Calling...'}
          </Typography>
          <Box sx={{ mt: 3 }}>
            <IconButton
              onClick={handleCancelCall}
              sx={{
                backgroundColor: theme.palette.error.main,
                color: theme.palette.common.white,
                width: 64,
                height: 64,
                '&:hover': {
                  backgroundColor: theme.palette.error.dark,
                },
              }}
            >
              <PhoneDisconnect size={32} />
            </IconButton>
          </Box>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default RingingModal;